export enum Features {
  // please keep this one at all times, is used for testing
  // and should stay even if no feature toggle is used at the moment
  FEATURE_TOGGLE_TEST = 'FEATURE_TOGGLE_TEST',
  // normal Features go here:
  GRAPHQL_GDPR_SELF_ASSESSMENT = 'GRAPHQL_GDPR_SELF_ASSESSMENT',
  MUNICH_DEMO = 'MUNICH_DEMO',
  DSBOSS_SCENARIOS_TABLE_PACE = 'DSBOSS_SCENARIOS_TABLE_PACE',
  EMERGENCY_DISABLE_SERVICE = 'EMERGENCY_DISABLE_SERVICE',
  STOP_NETWORK_IMPORTS = 'STOP_NETWORK_IMPORTS',
  SERVICE_BREAK_LOCATIONS = 'SERVICE_BREAK_LOCATIONS',
  KPI_DASHBOARD_ANNOTATIONS = 'KPI_DASHBOARD_ANNOTATIONS',
  DAMAGE_REPORT_V2 = 'DAMAGE_REPORT_V2',
  VEHICLE_CAPACITY_CONFIG = 'VEHICLE_CAPACITY_CONFIG',
  ADMIN_PANEL_PERMISSIONS_UI = 'ADMIN_PANEL_PERMISSIONS_UI',
  ROAD_NETWORK_KEEP_OUT_ZONES = 'ROAD_NETWORK_KEEP_OUT_ZONES',
  USE_LEGACY_SEARCH = 'USE_LEGACY_SEARCH',
} // DONT DELETE - template injection feature
